<template>
    <div class="">
        <liff-error-modal
            ref="errorModal"
            @ok-submit="closeWindow"
            :msg="errorMsg"
        />

        <div class="bg-liff">
            <div class="header-text">
                <div>
                    {{ $vuetify.lang.t('$vuetify.checkInSaleList.checkInSaleEngineer') }}
                </div>
                <span class="lang mr-3">
                    <change-lang />
                </span>
            </div>
            <div
                v-if="isDataTablePage"
                class="data-container">
                <div>
                    <v-card>
                        <v-data-table
                            :footer-props="{
                                'items-per-page-options': [10, 20, 30, 50, 100]
                            }"
                            @page-count="pageCount = $event"
                            :page.sync="page"
                            :headers="headers"
                            :options.sync="options"
                            :server-items-length="totalData"
                            :items="saleEngineers"
                            @click:row="edit"
                            :loading="loading">
                            <template v-slot:[`item.date`]="{ item }">
                               {{ $util.formatDate(item.date) }}
                            </template>
                        </v-data-table>
                    </v-card>
                    <div class="pt-2 paginator-box">
                       <div>
                           <v-pagination v-model="page" :length="pageCount"></v-pagination>
                       </div>
                    </div>
                </div>
            </div>
            <div v-else class="form-container">
                <v-container>
                    <v-row>
                        <v-col cols="6">
                            <v-text-field
                               :label="$vuetify.lang.t('$vuetify.checkInSaleList.jobId')"
                               v-model="form.job_no"
                               autocomplete="off"
                               placeholder="">
                            </v-text-field>
                        </v-col>
                        <v-col cols="6">
                            <v-text-field
                               :label="$vuetify.lang.t('$vuetify.checkInSaleList.customerName')"
                               v-model="form.customer_name"
                               autocomplete="off"
                               placeholder="">
                            </v-text-field>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="6">
                            <v-text-field
                               :label="$vuetify.lang.t('$vuetify.checkInSaleList.customerPerson')"
                               v-model="form.contact_person"
                               autocomplete="off"
                               placeholder="">
                            </v-text-field>
                        </v-col>
                        <v-col cols="6">
                            <v-text-field
                               :label="$vuetify.lang.t('$vuetify.checkInSaleList.customerPhone')"
                               v-model="form.contact_phone"
                               autocomplete="off"
                               placeholder="">
                            </v-text-field>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="4">
                            <v-menu
                              ref="startDate"
                              v-model="menu1"
                              :close-on-content-click="false"
                              transition="scale-transition"
                              offset-y
                              min-width="auto"
                            >
                              <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                  v-model="startDateFormatted"
                                  :label="$vuetify.lang.t('$vuetify.checkInSaleList.startDate')"
                                  readonly
                                  v-bind="attrs"
                                  v-on="on"
                                ></v-text-field>
                              </template>
                              <v-date-picker
                                v-model="form.start_date"
                                @input="menu1 = false"
                                @change="saveStartDate"
                                :max="birthdayConfig.max"
                              ></v-date-picker>
                            </v-menu>
                        </v-col>
                        <v-col cols="4">
                            <v-menu
                              ref="menu3"
                              v-model="menu3"
                              :close-on-content-click="false"
                              :return-value.sync="form.start_time"
                              transition="scale-transition"
                              max-width="290px"
                              min-width="290px"
                            >
                              <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                  v-model="form.start_time"
                                  :label="$vuetify.lang.t('$vuetify.checkInSaleList.startTime')"
                                  readonly
                                  v-bind="attrs"
                                  v-on="on"
                                ></v-text-field>
                              </template>
                              <v-time-picker
                                v-if="menu3"
                                v-model="form.start_time"
                                full-width
                                @click:minute="$refs.menu3.save(form.start_time)"
                              ></v-time-picker>
                            </v-menu>
                        </v-col>
                        <v-col cols="4">
                            <v-text-field
                               :label="$vuetify.lang.t('$vuetify.checkInSaleList.startMilieage')"
                               v-model="form.start_milieage"
                               type="number"
                               autocomplete="off"
                               placeholder="">
                            </v-text-field>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="4">
                            <v-menu
                              ref="endDate"
                              v-model="menu2"
                              :close-on-content-click="false"
                              transition="scale-transition"
                              offset-y
                              min-width="auto"
                            >
                              <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                  v-model="endDateFormatted"
                                  :label="$vuetify.lang.t('$vuetify.checkInSaleList.endDate')"
                                  readonly
                                  v-bind="attrs"
                                  v-on="on"
                                ></v-text-field>
                              </template>
                              <v-date-picker
                                v-model="form.end_date"
                                @input="menu2 = false"
                                @change="saveEndDate"
                                :min="birthdayConfig.max"
                              ></v-date-picker>
                            </v-menu>
                        </v-col>
                        <v-col cols="4" justify="center">
                            <v-menu
                              ref="menu4"
                              v-model="menu4"
                              :close-on-content-click="false"
                              :return-value.sync="form.end_time"
                              transition="scale-transition"
                              max-width="290px"
                              min-width="290px"
                            >
                              <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                  v-model="form.end_time"
                                  :label="$vuetify.lang.t('$vuetify.checkInSaleList.endTime')"
                                  readonly
                                  v-bind="attrs"
                                  v-on="on"
                                ></v-text-field>
                              </template>
                              <v-time-picker
                                v-if="menu4"
                                v-model="form.end_time"
                                full-width
                                @click:minute="$refs.menu4.save(form.end_time)"
                              ></v-time-picker>
                            </v-menu>
                        </v-col>
                        <v-col cols="4">
                            <v-text-field
                               :label="$vuetify.lang.t('$vuetify.checkInSaleList.endMilieage')"
                               v-model="form.end_milieage"
                               type="number"
                               autocomplete="off"
                               placeholder="">
                            </v-text-field>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12">
                            <v-text-field
                               :label="$vuetify.lang.t('$vuetify.checkInSaleList.activities')"
                               v-model="form.activities"
                               autocomplete="off"
                               placeholder="">
                            </v-text-field>
                        </v-col>
                    </v-row>
                    <v-row justify-content="center">
                        <v-col class="mx-auto" cols="12" align-content="center">
                            <span class="locate-font radio-label"> {{ $vuetify.lang.t('$vuetify.checkInSaleList.origin') }} </span>
                            <v-radio-group v-model="form.origin" row>
                                <v-radio
                                  v-for="radioLabel, index in radioLabels"
                                  :key="index"
                                  :label="radioLabel.name"
                                  :value="radioLabel.value"
                                ></v-radio>
                            </v-radio-group>
                        </v-col>
                    </v-row>
                    <v-row class="button-action">
                        <v-btn class="flex" color="primary" outlined @click="isDataTablePage = true">
                            {{ $vuetify.lang.t('$vuetify.checkInSaleList.cancel') }}
                        </v-btn>
                        <v-btn class="flex" color="primary" @click="sumbitForm">
                            {{ $vuetify.lang.t('$vuetify.checkInSaleList.submit') }}
                        </v-btn>
                    </v-row>
                </v-container>
            </div>
        </div>
    </div>
</template>

<script>
import ChangeLang from '@/components/liff/ChangeLang'
import LiffErrorModal from '@/components/modal/LiffErrorModal'
import axios from 'axios'
export default {
    name: 'CheckInSaleList',
    components: {
        ChangeLang,
        LiffErrorModal
    },

    data () {
        return {
            tab: null,
            lineId: null,
            lineIdToken: null,
            status: null,
            saleEngineers: [],
            pageCount: 1,
            page: 1,
            totalData: 0,
            options: {},
            loading: false,
            errorMsg: '',
            isDataTablePage: true,
            menu1: false,
            menu2: false,
            menu3: false,
            menu4: false,
            radioLabels: [],
            form: {
                job_no: '',
                customer_name: '',
                contact_person: '',
                contact_phone: '',
                origin: '',
                start_date: '',
                start_time: '',
                start_milieage: '',
                end_date: '',
                end_time: '',
                end_milieage: '',
                activities: ''
            },
            inputRules: [
                v => this.$validator.hasValue(v, this.$vuetify.lang.t('$vuetify.checkInSaleList.msgRequiredField')),
                v => this.$validator.lengthNotExceed(v, 255, this.$vuetify.lang.t('$vuetify.checkInSaleList.msgExceededField'))
            ],
            startDateFormatted: null,
            endDateFormatted: null,
            birthdayConfig: {
                min: `${new Date().getFullYear() - 100}-01-01`,
                max: this.$util.getCurrentDate()
            }
        }
    },

    computed: {
        localeLang () {
            return this.$vuetify.lang.current
        },
        headers () {
            return [
                { text: this.$vuetify.lang.t('$vuetify.checkInSaleList.jobId'), value: 'job_no', width: '20%' },
                { text: this.$vuetify.lang.t('$vuetify.checkInSaleList.customerName'), value: 'customer_name', width: '20%' },
                { text: this.$vuetify.lang.t('$vuetify.checkInSaleList.address'), value: 'address', width: '40%' },
                { text: this.$vuetify.lang.t('$vuetify.checkInSaleList.date'), value: 'date', width: '20%' }
            ]
        }
    },

    methods: {
        setStatus (status) {
            this.status = ''
            this.status = status
        },

        closeWindow () {
            this.$liff.closeWindow()
        },

        errorAlert (message) {
            this.$store.dispatch('setLoading', false)
            this.$refs.errorModal.dialog = true
            this.errorMsg = message
        },

        async getCheckInPagination () {
            this.loading = true
            const { sortBy, sortDesc, page, itemsPerPage } = this.options

            let url = `${process.env.VUE_APP_BACKEND}/sale-engineer-onsite-today?line_id=${this.lineId}`
            if (page) {
                url += `&page=${page}`
            }
            if (itemsPerPage) {
                url += `&itemsPerPage=${itemsPerPage}`
            }
            if (sortBy && sortBy[0]) {
                url += `&sortBy=${sortBy[0]}`
            }
            if (sortDesc && sortDesc[0]) {
                url += `&sortDesc=${sortDesc[0]}`
            }
            if (this.status) {
                url += `&status=${this.status}`
            }

            const res = await axios.get(url)
            if (res && res.data && res.data.status === 'ok') {
                this.saleEngineers = res.data.data
                this.totalData = res.data.total
            }
            this.loading = false
            this.isDataTablePage = true
        },

        edit (data) {
            this.isDataTablePage = false
            this.form = data
            this.startDateFormatted = this.$util.formatDate(data.start_date)
            this.endDateFormatted = this.$util.formatDate(data.end_date)
        },

        async sumbitForm () {
            const url = `${process.env.VUE_APP_BACKEND}/sale-engineer-onsite-today/${this.form.id}`
            const form = {
                lineIdToken: this.lineIdToken,
                job_no: this.form.job_no,
                customer_name: this.form.customer_name,
                contact_person: this.form.contact_person,
                contact_phone: this.form.contact_phone,
                origin: this.form.origin,
                start_date: this.form.start_date,
                start_time: this.form.start_time,
                start_milieage: this.form.start_milieage,
                end_date: this.form.end_date,
                end_time: this.form.end_time,
                end_milieage: this.form.end_milieage,
                activities: this.form.activities
            }
            this.$store.dispatch('setLoading', true)
            let message = ''
            let type = ''
            const res = await axios.post(url, form)
            if (res && res.data && res.data.status === 'ok') {
                message = res.data.data
                type = 'success'
            } else if (res && res.data && res.data.status === 'error') {
                message = res.data.msg
                type = 'error'
            }
            this.$store.dispatch('setLoading', false)
            this.isDataTablePage = true
            this.$notify({
                title: message,
                text: null,
                type: type
            })
        },

        getRadioLabels () {
            this.radioLabels = [
                {
                    name: this.localeLang === 'en' ? 'Home' : 'บ้าน',
                    value: 'HOM'
                },
                {
                    name: this.localeLang === 'en' ? 'Office' : 'ที่ทำงาน',
                    value: 'OFF'
                },
                {
                    name: this.localeLang === 'en' ? 'Customer' : 'ลูกค้า',
                    value: 'CUS'
                }
            ]
        },

        saveStartDate (date) {
            this.$refs.startDate.save(date)
            this.startDateFormatted = this.$util.formatDate(date)
        },

        saveEndDate (date) {
            this.$refs.endDate.save(date)
            this.endDateFormatted = this.$util.formatDate(date)
        }
    },

    async mounted () {
        this.$store.dispatch('setLoading', true)
        try {
            this.lineId = await this.$util.getLineIdForLiff(process.env.VUE_APP_LINE_CHECK_IN_SALE_LIST_URL)
            // this.lineIdToken = await this.$util.getLineIdToken(process.env.VUE_APP_LINE_CHECK_IN_SALE_LIST_URL)
            // this.lineId = 'U911d4ef1b4ce16c7a361477803c7f35f'
            await this.getCheckInPagination()
            this.getRadioLabels()
        } catch (error) {
            this.errorAlert(this.$vuetify.lang.t('$vuetify.liffOvertimeRequest.cannotGetLineId'))
        }
        this.$store.dispatch('setLoading', false)
    },

    watch: {
        '$vuetify.lang.current': {
            handler () {
                this.getRadioLabels()
            }
        },
        options: {
            async handler () {
                if (this.lineId) await this.getCheckInPagination()
            }
        }
    }
}
</script>

<style lang="scss" scoped>
::v-deep.v-input--selection-controls {
    margin-top: 0px !important;
}

.radio-label {
    font-size: 16px;
    color: #00000099;
}
.button-action {
    display: flex;
    gap: 24px;
    padding: 24px;
}
.bg-liff {
    height: 100vh;
    background-color: #2E2929;
    color: #ffffff;

    .header-text {
        font-family: LexendDeca;
        font-size: 20px;
        padding: 1rem;
        height: 10%;
        min-height: 45px;
        display: flex;
        justify-content: space-between;
        align-items: center;
    }

    .data-container {
        background: #ffffff;
        border-top-right-radius: 30px;
        border-top-left-radius: 30px;
        color: #6c6c6c;
        padding: 2rem;
        font-size: 14px;
        font-weight: normal;
        overflow: scroll;
        height: 90%;
    }

    .form-container {
        overflow: scroll;
        height: 90%;
        background: #ffffff;
        border-top-right-radius: 30px;
        border-top-left-radius: 30px;
    }
}

@media screen and (orientation: landscape) {
    .bg-liff {
        display: flex;
        flex-direction: column;
        align-items: center;

        .data-container {
            min-width: 350px;
        }
    }
}

.lang {
    display: flex;
    justify-content: center;
    flex-direction: column;
    font-size: 18px;
    &-th{
        font-family: Prompt;
    }
    &-en{
        font-family: LexendDeca;
    }
}

::v-deep .v-data-footer__icons-before {
    display: none;
}
::v-deep .v-data-footer__icons-after {
    display: none;
}
</style>
